'use client'

import { useEffect } from 'react'
import { usePathname, useSearchParams } from 'next/navigation'
import sendToBothAnalytics from '@/lib/mixpanel/sendToBothAnalytics'
import { useCurrentUser } from '@/hooks/use-current-user'
import { MIXPANEL_CLIENT_EVENT_NAMES } from '@/lib/mixpanel/constant'
import { IS_PROD } from '@/lib/constant'

export function PageView() {
  const pathname = usePathname()
  const searchParams = useSearchParams()
  const { data: user, isLoading } = useCurrentUser()
  useEffect(() => {
    // Function to send page view analytics to Mixpanel
    const sendPageView = () => {
      if (!IS_PROD) {
        // Not send to Mixpanel in non-prod environments
        return
      }
      sendToBothAnalytics(
        MIXPANEL_CLIENT_EVENT_NAMES.PAGE_VIEW,
        {
          path: pathname,
          query: searchParams.toString(),
          page_title: document.title,
        },
        user?._id.toString(),
      )
    }
    if (!isLoading) {
      sendPageView()
    }
  }, [pathname, searchParams, user, isLoading])

  return null
}
